import { AlertTriangle, X } from "lucide-react";
import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: React.ReactNode;
}

export const ConfirmationModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  icon = <AlertTriangle className="w-6 h-6 text-red-500" />,
}) => {
  if (!isOpen) return null;

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 transition-opacity"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md transform transition-all"
        onClick={handleContentClick}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              {icon}
              <h2 className="text-xl font-bold text-gray-900">{title}</h2>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 transition"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="mb-6">
            <p className="text-gray-600">{message}</p>
          </div>
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="flex items-center px-3 py-2 bg-gray-100 text-gray-700 font-semibold rounded hover:bg-gray-200 transition bg-gray-200 hover:bg-gray-300 transition-colors"
            >
              <X className="w-4 h-4 mr-1" />
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              className="flex items-center px-3 py-2 bg-red-500 text-white font-semibold rounded hover:bg-red-600 transition"
            >
              <AlertTriangle className="w-4 h-4 mr-1" />
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
